module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk_sentrert logo_neg(hvit).c3daf526.pdf";